var exports = {
  "q": "xe30f6088--9d5ca6--footer-legal",
};

module.exports = exports;
